import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { yen } from "@/lib/format";
import { Loader2 } from "lucide-react";

const ST = {
  paid: { l: "入金済", c: "bg-emerald-500/15 text-emerald-400" },
  issued: { l: "請求済", c: "bg-blue-500/15 text-blue-400" },
  partial: { l: "一部入金", c: "bg-amber-500/15 text-amber-400" },
  arrears: { l: "滞納", c: "bg-red-500/15 text-red-400" },
  unpaid: { l: "未入金", c: "bg-gray-500/15 text-gray-300" },
};

export default function TenantInvoices() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/tenant/invoices").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  if (rows === null) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;

  return (
    <div data-testid="tenant-invoices">
      <h1 className="font-display text-2xl font-light mb-6">家賃・お支払い</h1>
      {rows.length === 0 ? (
        <div className="text-gray-500 text-sm py-10 text-center bg-[#161616] rounded-lg">請求はまだありません。</div>
      ) : (
        <div className="bg-[#161616] border border-white/5 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-gray-500 border-b border-white/5">
              <tr><th className="px-4 py-3">対象月</th><th className="px-4 py-3 text-right">請求額</th><th className="px-4 py-3 text-right">残額</th><th className="px-4 py-3">支払期日</th><th className="px-4 py-3">状態</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const st = ST[r.status] || ST.unpaid;
                return (
                  <tr key={r.id} className="border-t border-white/5" data-testid={`invoice-row-${r.id}`}>
                    <td className="px-4 py-3">{r.year_month}</td>
                    <td className="px-4 py-3 text-right">{yen(r.amount)}</td>
                    <td className={`px-4 py-3 text-right ${(r.balance || 0) > 0 ? "text-red-400" : "text-gray-500"}`}>{yen(r.balance || 0)}</td>
                    <td className="px-4 py-3 text-gray-400">{r.due_date}</td>
                    <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${st.c}`}>{st.l}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-xs text-gray-500 mt-4">お支払い方法についてのご不明点は、お問い合わせよりご連絡ください。</p>
    </div>
  );
}
